import React, { Component } from "react";
import { Frame, FrameRiskTree } from "../type";

type Props = {
  frame: Frame;
  frameScale: number;
  frameRiskTree: FrameRiskTree;
  focusRiskLabel: string;
};

type State = Record<string, unknown>;

const riskThreshold = 1e-2;

export default class ScalableFrame extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  getDefaultStyle() {
    return {
      transform: `scale(1)`,
    };
  }

  getFocusStyle() {
    return {
      transform: `scale(${this.props.frameScale})`,
      zIndex: 100,
    };
  }

  getFrameStyle() {
    const { frameRiskTree, focusRiskLabel } = this.props;
    if (frameRiskTree && focusRiskLabel) {
      const [riskType, riskTag] = focusRiskLabel.split("_");
      return frameRiskTree[riskType][riskTag] > riskThreshold
        ? this.getFocusStyle()
        : this.getDefaultStyle();
    }
    return this.getDefaultStyle();
  }

  render() {
    const { frame } = this.props;
    return (
      <div className="scalable-frame" style={this.getFrameStyle()}>
        <img
          src={frame.src}
          style={{
            width: `${frame.size[0]}px`,
            height: `${frame.size[1]}px`,
          }}
        />
      </div>
    );
  }
}
